import React, { FC } from 'react';
import { Badge, Flex } from 'antd';
import { Tooltip } from '../common/components/Tooltip';
import styled from 'styled-components';
import {
  colorDraftBg,
  colorDraftBorder,
  colorGray,
  colorInactiveBg,
  colorInactiveBorder,
  colorSuccessBg,
  colorSuccessBorder,
  fontWeightStrong,
} from '@atlas-frontend/design-tokens';
import { DATE_FORMAT, getValidPeriodString } from '../common/utils';
import { DataObjectFormDataType } from './types';
import { useSystemClassifierSelectOptions } from '../configuration';

type Props = {
  version: DataObjectFormDataType;
};

export const DataObjectVersionLabel: FC<Props> = ({ version }) => {
  const { DATA_OBJ_GRP_VER_STATUS } = useSystemClassifierSelectOptions(
    ['DATA_OBJ_GRP_VER_STATUS'],
    'code'
  );
  return (
    <Tooltip title={version.description} placement="left">
      <DataObjectVersionFlex className={version.statusCode} gap="small">
        <DataObjectVersionBadge
          count={version.versionNumber}
          showZero
          color="black"
          size="small"
        />{' '}
        {getValidPeriodString(version.validPeriod, DATE_FORMAT)}{' '}
        {
          DATA_OBJ_GRP_VER_STATUS.find(
            (item) => item.value === version.statusCode
          )?.label
        }
      </DataObjectVersionFlex>
    </Tooltip>
  );
};

const DataObjectVersionFlex = styled(Flex)`
  border: 1px solid;
  align-items: center;
  font-size: 11px;
  font-weight: ${fontWeightStrong};
  letter-spacing: 0.1em;
  height: 24px;
  color: ${colorGray[8]};
  margin: auto 0;
  padding-inline: 11px;
  border-radius: 6px;

  &.DRAFT {
    border-color: ${colorDraftBorder};
    background-color: ${colorDraftBg};
  }
  &.ACTIVE {
    border-color: ${colorSuccessBorder};
    background-color: ${colorSuccessBg};
  }
  &.INACTIVE {
    border-color: ${colorInactiveBorder};
    background-color: ${colorInactiveBg};
  }
`;

const DataObjectVersionBadge = styled(Badge)`
  .ant-badge-count {
    font-size: 11px;
    box-shadow: none;
    border-radius: 3px;
    color: white;
    padding-inline: 2px;
  }
`;
